import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const saveMarketplaceCategories = async ({ marketplaceId, categories }) => {
  const response = await axiosInstance.post(
    `/marketplaces/${marketplaceId}/save_categories/`,
    { categories }
  );
  return response.data;
};

export const useSaveMarketplaceCategories = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: saveMarketplaceCategories,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mp-categories'] });
    },
    retry: 0,
  });

  return {
    saveCategories: mutation.mutate,
    saveCategoriesAsync: mutation.mutateAsync,
    isSaving: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    reset: mutation.reset,
  };
};
